import APIService from "./APIService";

export default {
    async getAll() {
        const res = await APIService.apiCall().get('regionais/get-regionais');
        return res.data;
    },
    async getById(id) {
        const res = await APIService.apiCall().get(`regionais/get-by-id/${id}`);
        return res.data;
    },
    async create(postData) {
        const res = await APIService.apiCall().post(`regionais/create`, postData);
        return res.data;
    },
    async update(id, postData) {
        const res = await APIService.apiCall().put(`regionais/update/${id}`, postData);
        return res.data;
    },
    async delete(id) {
        const res = await APIService.apiCall().delete(`regionais/delete/${id}`);
        return res.data;
    },
};